import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  usersListUl: {
    padding: '0 0 0 19px',
    margin: '0',
  },
  usersListElement: {
    listStyle: 'none',
    cursor: 'pointer',
    position: 'relative',
    borderLeft: '1px solid #656681',
    padding: '0 0 9px 6px',
    '&:last-of-type': {
      borderLeft: 'none',
      '&:not(:first-of-type) $usersListElementLine': {
        height: '19px',
        left: '0px',
      },
    },
  },
  usersListElementFirst: {
    paddingLeft: '0px',
    cursor: 'default',
  },
  usersListElementOpened: {
    borderLeft: 'none',
    '&:not(:first-of-type) $usersListElementLine': {
      height: '19px',
      left: '0px',
    },
  },
  usersListElementLine: {
    width: '7px',
    height: '16px',
    position: 'absolute',
    borderBottom: '1px solid #656681',
    borderLeft: '1px solid #656681',
    left: '-1px',
    top: '0px',
  },
  usersListElementContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '4px',
    borderRadius: '5px',
    '&:hover': {
      background: 'rgba(60, 65, 154, 0.4)',
    },
  },
  usersListElementContentActive: {
    background: '#3C419A',
  },
  userListElementTooltip: {
    background: '#FFFFFF',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '3px',
    color: '#2C2D3E',
  },
  userListElementTooltipText: {
    margin: '0 0 3px 0',
    fontSize: '1em',
    lineHeight: '14px',
  },
  usersListElementContentIcon: {
    fontSize: '10px',
    marginRight: '5px',
  },
  usersListElementText: {
    maxWidth: '100px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    padding: '8px 4px',
    fontSize: '14px',
    lineHeight: '16px',
  },
  usersListElementTextActive: {
    color: '#FFFFFF',
    fontWeight: 'normal',
  },
  usersListElementHighlighted: {
    background: '#3560FF',
    padding: '3px 2px 4px 2px',
  },
  lockIcon: {
    '&.MuiSvgIcon-root': {
      width: '15px',
      height: '15px',
      position: 'relative',
      transform: 'translate(-22px, 0px)',
    },
  },
  autolockIcon: {
    width: '15px',
    height: '15px',
    position: 'relative',
    transform: 'translate(-22px, 0px)',
  },
  loginIcon: {
    verticalAlign: 'bottom',
    backgroundColor: 'white',
    borderRadius: '50%',
  },
}));
